import { ApiObjectData } from './core/models/api-object-data';
import { BaseService } from './core/service/base.service';
import { Component, OnInit } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PlatformLocation } from '@angular/common';
import { JwtHelperService } from '@auth0/angular-jwt';
import { locale, loadMessages } from 'devextreme/localization';
import config from 'devextreme/core/config';
import { AuthService } from './core/service/auth.service';
import { User } from './core/models/user';
import messages from '../assets/data/devextreme/locale.json';
import { TranslateService } from '@ngx-translate/core';
import { UrlService } from 'src/app/core/service/url.service';
import { filter, takeUntil } from 'rxjs/operators';
import { DashboardService } from '../app/core/service/dashboard.service';
import { BaseComponent } from './components/base/base.component';
import { DashboardData } from '../app/core/models/dashboardData';
import { environment } from '../environments/environment'
import * as $ from 'jquery';
import { BehaviorSubject } from 'rxjs';
import { AlertService } from '../app/core/service/alert.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  currentUrl: string;
  jwtHelper = new JwtHelperService();
  previousUrl: string = null;
  presentUrl: string = null;
  rolemenus: any[]=[];
  detail: boolean;
  users: boolean;
  externalUsers: boolean;
  request: boolean;
  hasUserPermission: any;
  currentUserSubject: BehaviorSubject<User>;
  currentUserData: User;
  addRequest: boolean;
  requestDetailsWithout:any;
  menuRequest:any;
  constructor(
    public router: Router,
    location: PlatformLocation,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private baseService: BaseService,
    private translate: TranslateService,
    private urlService: UrlService,
    private dashboardService: DashboardService,
    private alertService: AlertService
  ) {

    // this.router.events.subscribe((routerEvent: Event) => {
    //   if (routerEvent instanceof NavigationStart) {
    //     this.spinner.show();
    //     location.onPopState(() => {
    //       window.location.reload();
    //     });
    //     if (routerEvent.url.includes('authentication') || routerEvent.url.includes('home') || routerEvent.url.includes('external-approve') || routerEvent.url.includes('userprofile') || routerEvent.url.includes('changePassword') || routerEvent.url.includes('/page/Profile')) {
    //       this.currentUrl = routerEvent.url.substring(
    //         routerEvent.url.lastIndexOf('/') + 1
    //       );

    //       if (routerEvent.url.includes('home')) {
    //         this.rolemenus = JSON.parse(localStorage.getItem('menuPaths'));
    //         this.dashboardService.gets().subscribe(
    //           (data: ApiObjectData) => {
    //             console.log(data.returnData);
    //             let dashboardData = data.returnData as DashboardData;
    //             if (dashboardData.waitingRequestsCount > 0 || dashboardData.pendingRequestsCount > 0) {
    //             //     let requestDetails= localStorage.setItem('menuRequest', JSON.stringify('/page/request-details/'));
    //             let requestDetails = '/page/request-details/';
    //               this.rolemenus.push(requestDetails);
    //             }

    //             if (dashboardData.confirmedRequestsCount > 0 || dashboardData.refusedRequestsCount > 0 || dashboardData.underProcRequestsCount > 0 || dashboardData.pendingRequestsCount > 0) {
    //                 // let withoutedit= localStorage.setItem('menuRequestWithout', JSON.stringify('/page/request-details-without-edit/'));
    //             let withoutedit = '/page/request-details-without-edit/';
    //               this.rolemenus.push(withoutedit);
    //             }
    //           }
    //         )
    //       }
    //     }

    //     else {

    //       // this.rolemenus = JSON.parse(localStorage.getItem('menuPaths'));
    //     //   this.menuRequest=JSON.parse(localStorage.getItem('menuRequest'))
    //     //  this. = JSON.parse(localStorage.getItem('menuRequestWithout'));
    //      // var menuReq = JSON.parse(localStorage.getItem('menuRequest'));
    //     //  var menuReqWithout = JSON.parse(localStorage.getItem('menuRequestWithout'));
    //       //this.rolemenus.push(menuReq);
    //      // this.rolemenus.push(menuReqWithout);

    //       // this.currentUserSubject = new BehaviorSubject<User>(
    //       //   JSON.parse(localStorage.getItem('user'))
    //       // );
    //       this.currentUserData = JSON.parse(localStorage.getItem('user'));
    //       if(this.currentUserData === null) {
    //         this.router.navigate(['/authentication/signin'])
    //       }

    //       else {
    //         if (this.currentUserData.isRegister === true) {
    //           this.rolemenus.push('/page/myPayments');
    //           this.rolemenus.push('/page/paymentResult');
    //           this.rolemenus.push('/page/myPackages');
    //           this.rolemenus.push('/page/billings');
  
    //         }
    //       }

    //       //  if (this.currentUserSubject.value.isRegister === true) {
    //       // if (this.currentUserData.isRegister === true) {
    //       //   this.rolemenus.push('/page/myPayments');
    //       //   this.rolemenus.push('/page/paymentResult');
    //       //   this.rolemenus.push('/page/myPackages');
    //       //   this.rolemenus.push('/page/billings');

    //       // }


    //       //   this.users = routerEvent.url.includes('user')
    //       //   if(this.users === true ){
    //       //   let restUrl=routerEvent.url.substring(1)
    //       //   this.currentUrl =this.baseService.appUrl + restUrl;
    //       //   this.rolemenus.push(routerEvent.url);
    //       //  }
    //       //   this.externalUsers = routerEvent.url.includes('externaluser')

    //       //   this.request  = routerEvent.url.includes('request')


    //       localStorage.setItem('menuPaths', JSON.stringify(this.rolemenus));

    //       if (this.rolemenus.length > 0) {
    //         // this.rolemenus.forEach(e=>{
    //         //   this.hasUserPermission=e.includes('users')
    //         // });
    //         let x = routerEvent.url.includes('request-details')
    //         this.hasUserPermission = routerEvent.url.includes('user')
    //         this.addRequest = routerEvent.url.includes('request')
    //         if (x === true || this.hasUserPermission === true || this.addRequest === true) {

    //           this.rolemenus.forEach(element => {
    //             this.detail = element.includes('request-details')
    //             this.users = element.includes('user')
    //             // this.request = element.includes('request')

    //             if (this.detail === true) {
    //               // this.currentUrl = routerEvent.url.substring(
    //               //   routerEvent.url.lastIndexOf('/') + 1
                    
    //               // );
    //               let restUrl = routerEvent.url.substring(1)
    //               this.currentUrl = this.baseService.appUrl + restUrl;
    //             }
    //             if (this.users === true) {
    //               let restUrl = routerEvent.url.substring(1)
    //               this.currentUrl = this.baseService.appUrl + restUrl;
    //               this.rolemenus.push(routerEvent.url);
    //             }
    //             // if (this.request === true) {
    //             //   let restUrl = routerEvent.url.substring(1)
    //             //   this.currentUrl = this.baseService.appUrl + restUrl;
    //             //   this.rolemenus.push(routerEvent.url);
    //             // }
    //           });
    //           if (this.detail === false && this.users === false) {
    //             let url = this.rolemenus.find(el => el === routerEvent.url)

    //             if (url) {
    //               this.currentUrl = routerEvent.url.substring(
    //                 routerEvent.url.lastIndexOf('/') + 1
    //               );
    //             }
    //             else {
    //               this.router.navigate(['/authentication/signin'])
    //             }
    //           }
    //         }

    //         // else if (x === false) {
    //         else {
    //           let url = this.rolemenus.find(el => el === routerEvent.url)

    //           if (url) {
    //             this.currentUrl = routerEvent.url.substring(
    //               routerEvent.url.lastIndexOf('/') + 1
    //             );
    //           }

              

    //           else {
    //             this.router.navigate(['/authentication/signin'])

    //           }

    //         }
    //       }
    //       else{
    //         this.router.navigate(['/page/home']);
    //         this.alertService.error(this.translate.instant('ليس لديك الصلاحية'));
    //       }
    //     }
    //   }

    //   if (routerEvent instanceof NavigationEnd) {
    //     this.spinner.hide();
    //   }
    //   window.scrollTo(0, 0);
    // });

    this.router.events.subscribe((routerEvent: Event) => {
      this.rolemenus = JSON.parse(localStorage.getItem('menuPaths'));
      if (routerEvent instanceof NavigationStart) {
        this.spinner.show();
        location.onPopState(() => {
          window.location.reload();
        });
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        this.spinner.hide();
      }
      window.scrollTo(0, 0);
    });

  }
  ngOnInit() {
    ///to detect previous url
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.presentUrl;
      this.presentUrl = event.url;
      this.urlService.setPreviousUrl(this.previousUrl);
    });

    loadMessages(messages);
    if (localStorage.getItem('dir')) {
      this.baseService.dir = localStorage.getItem('dir');
      this.baseService.lang = localStorage.getItem('lang');
      this.baseService.isRTL = localStorage.getItem('dir') === 'rtl' ? true : false;
    }
    else {
      this.baseService.dir = 'rtl';
      this.baseService.lang = 'ar';
      this.baseService.isRTL = true;
      localStorage.setItem('dir', this.baseService.dir);
      localStorage.setItem('lang', this.baseService.lang);
    }
    config({ rtlEnabled: this.baseService.isRTL });
    locale(this.baseService.lang);
    this.translate.use(this.baseService.lang);
    document.getElementsByTagName('html')[0].setAttribute('dir', this.baseService.dir);
    document.getElementsByTagName('body')[0].classList.remove(this.baseService.dir === 'rtl' ? 'ltr' : 'rtl');
    document.getElementsByTagName('body')[0].classList.add(this.baseService.dir);

    // const token = localStorage.getItem('token');
    // const user: User = JSON.parse(localStorage.getItem('user'));
    // if (token) {
    //   this.authService.decodedToken = this.jwtHelper.decodeToken(token);
    // }
    // if (user) {
    //   this.authService.currentUser = user;
    // }

  }
}
